<template>
  <div class="header-wrapper">
    <div class="header">
      <div class="logo-and-action-menu">
        <RouterLink
          class="brand-logo"
          :to="{ name: 'VaCallList' }"
        >
          <img
            :src="brandLogo"
            height="25.5"
          >
        </RouterLink>
        <div class="voice-analytics-title">
          {{ $t('vaApp.title') }}
        </div>
      </div>
      <div class="right-content">
        <RouterLink
          class="setting-icon"
          :to="{ name: 'VaSetting' }"
        >
          <BCustomIcon
            icon-class="b-setting"
          />
        </RouterLink>
        <div class="bar" />
        <div class="client-name">
          {{ currentUser?.clientName }}
        </div>
        <VaAppHeaderMenu />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import brandLogo from '@/assets/brand_logo.svg';
import VaAppHeaderMenu from '@/components/organisms/va-app/VaAppHeaderMenu.vue';
import { useCurrentUserProvider } from '@/composable/current-user';

const { inject: injectCurrentUser } = useCurrentUserProvider();
const { currentUser } = injectCurrentUser();
</script>

<style lang="scss" scoped>
  .header-wrapper {
    @include m-fixed-width(0px);
    transition: $transition-base;
    position: relative;

    .header {
      @include m-fixed-width(100vw);
      @include m-fixed-height(50px);
      position: fixed;
      background:  #EAF9F8;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 9;
      box-shadow: 0 2px 6px 0 $shadowcolor-base;
    }
  }

  .brand-logo {
    margin-top: 6px;
    margin-left: 22px;
  }

  .voice-analytics-title {
    margin-left: 6px;
    display: flex;
    padding: 3px 10px;
    align-items: flex-start;
    border-radius: 14px;
    background: $basecolor-primary;
    color: $textcolor-white;
    font-family: Rubik;
    font-size: $fontsize-100;
    font-style: normal;
    font-weight: 500;
    line-height: 12px;
  }

  .right-content {
    @include m-flex-align-center;
    @include m-flex-justify-right;
    flex-wrap: nowrap;
    height: $header-height;
  }

  .setting-icon {
    display: flex;
    align-items: center;
    padding-inline: $basespace-100;
    transition: $transition-base;
    text-decoration: none;
    &:hover {
      background-color: $bgcolor-dark;
    }
  }

  .bar {
    display: inline-flex;
    align-items: center;
    width: 2px;
    height: 16px;
    background: #D9D9D9;
    margin-inline: 8px;
    margin-block: auto;
  }

  .client-name {
    display: inline-flex;
    align-items: center;
    font-size: $fontsize-100;
    font-weight: 400;
    line-height: 12px;
    background-color: $bgcolor-white;
    margin-block: auto;
    margin-right: $basespace-100;
    padding: $basespace-100;
    border-radius: 8px;
  }

  .logo-and-action-menu {
    display: flex;
    align-items: center;
  }
</style>
